import React, { useState } from 'react';
import { useDlcRegister, useDlcTypeDrop } from 'apis/story/dlcApis';
import DefaultButton from 'components/button/DefaultButton';
import DefaultModal from 'components/modal/DefaultModal';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import DefaultForm from 'components/form/DefaultForm';
import { useTranslation } from 'react-i18next';
/**
 * * 작품 관리 - DLC 등록 모달
 */

interface IDlcProps {
  dlc_name: string;
  dlc_type: string;
}
interface IProps {
  projectId: string;
  visible: boolean;
  setVisible: (e: any) => void;
}
const DLCRegisterModal = ({ projectId, visible, setVisible }: IProps) => {
  const [inputData, setInputData] = useState<IDlcProps>({
    dlc_name: '',
    dlc_type: 'free',
  });
  const { t } = useTranslation();
  const { data: dlcTypeDropList } = useDlcTypeDrop();

  const { mutate: dlcRegister } = useDlcRegister(setVisible, setInputData);

  const handleInputChange = (e) => {
    setInputData({ ...inputData, dlc_name: e.target.value });
  };
  const handleSelectChange = (value: string, data: any) => {
    setInputData({ ...inputData, dlc_type: value });
  };

  /// 등록하기
  const handleSubmit = () => {
    if (inputData.dlc_name === '') {
      alert('관리형 이름을 입력해 주세요.');
      return;
    }
    // 서버 전송 쿼리
    dlcRegister({
      projectId,
      inputData,
    });
  };
  const handleClose = () => {
    setVisible(false);
    setInputData({ dlc_name: '', dlc_type: 'free' });
  };
  return (
    <DefaultModal
      title={t(
        'storyEpisodeID.storyTabMenuList.DLCContent.createDLCModal.title',
      )}
      visible={visible}
      onCancel={handleClose}
      footer={
        <DefaultButton onClick={handleSubmit}>
          {t(
            'storyEpisodeID.storyTabMenuList.DLCContent.createDLCModal.submit',
          )}
        </DefaultButton>
      }
    >
      <DefaultForm>
        <DefaultInput
          title={t(
            'storyEpisodeID.storyTabMenuList.DLCContent.createDLCModal.DLCName',
          )}
          name='dlc_name'
          value={inputData.dlc_name}
          onChange={handleInputChange}
        />
        <DefaultSelect
          title={t(
            'storyEpisodeID.storyTabMenuList.DLCContent.createDLCModal.DLCType',
          )}
          name='dlc_type'
          value={inputData.dlc_type}
          optionList={dlcTypeDropList}
          onChange={handleSelectChange}
        />
      </DefaultForm>
    </DefaultModal>
  );
};

export default DLCRegisterModal;
